var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounderLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 13,
    y1: 9,
    x2: 67,
    y2: 71
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE2D0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 4,
    y: 6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 9,
    floodColor: "#4B3420",
    floodOpacity: 0.08
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 54,
    height: 54,
    rx: 20,
    fill: "url(#bg)",
    filter: "url(#d)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.5 44.3 34.2 54 35.6 47 42.4 48.7 52 40 47.5 31.3 52 33 42.4 26 35.6 35.7 34.2 40 25.5Z",
    stroke: "#073F37",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56H52",
    stroke: "#8B642C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderLoyalty);
export default __webpack_public_path__ + "static/media/founder-loyalty.e20756f54c4fc98b14a2ed8fc9f2d038.svg";
export { ForwardRef as ReactComponent };